import {
  SupportTicketStatus,
  TICKET_STATUS_LABELS,
} from "entities/support-ticket";
import type { TabItem } from "shared/ui";

export type StatusFilter = SupportTicketStatus | "all";

export const STATUS_FILTERS: TabItem<StatusFilter>[] = [
  { value: "all", label: "All" },
  ...Object.values(SupportTicketStatus).map((status) => ({
    value: status,
    label: TICKET_STATUS_LABELS[status],
  })),
];
